
import NavbarWrapper from './containers/Navbar/NavbarWrapper';
import './styles/App.css';

function App() {
  return (
    <NavbarWrapper />
  );
}

export default App;
